import { useEffect, useState } from 'react';

import { getOrganizationTheme } from 'api/organizations';
import { useCopilotConfiguration } from 'data/copilot';
import { OrganizationTheme } from 'interfaces';

import CopilotLayout from './CopilotLayout';

type CopilotRootProps = {
  organizationId?: number;
  onDismiss?: () => void;
};

export default function CopilotRoot(props: CopilotRootProps) {
  const { organizationId, onDismiss } = props;

  const [organizationTheme, setOrganizationTheme] = useState<OrganizationTheme | null>(null);
  const { copilotConfiguration } = useCopilotConfiguration();

  useEffect(() => {
    const fetchOrganizationTheme = async () => {
      let fetchedOrganizationTheme: OrganizationTheme | null = null;

      if (organizationId) {
        fetchedOrganizationTheme = await getOrganizationTheme(organizationId);
      }

      setOrganizationTheme(fetchedOrganizationTheme);
    };

    fetchOrganizationTheme();
  }, [organizationId]);

  return (
    <>
      {copilotConfiguration && (
        <CopilotLayout
          copilotConfiguration={copilotConfiguration}
          organizationTheme={organizationTheme}
          onDismiss={onDismiss}
        />
      )}
    </>
  );
}
